module.exports = __webpack_public_path__ + "img/Sample_Certificate_PMI.24e2af52.png";